import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Calendar, Clock, AlertCircle } from "lucide-react";

export const DateTimeCard = ({ customDate, customTime, dateModified, userName, onDateChange, onTimeChange, onReset }) => (
  <div className="bg-white rounded-xl border border-[#edf0f4] p-6 mb-6 shadow-sm">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className={`p-4 rounded-lg ${dateModified ? 'bg-[#f59e0b]/10 border border-[#f59e0b]/30' : 'bg-[#f4f7fa]'}`}>
        <div className="flex items-center justify-between mb-2">
          <p className="text-xs text-[#8fa4b5] uppercase tracking-wide flex items-center gap-1"><Calendar size={12} /> Date</p>
          {dateModified && <span className="text-[10px] text-[#f59e0b] font-medium px-1.5 py-0.5 bg-[#f59e0b]/20 rounded">Modifiée</span>}
        </div>
        <Input type="date" value={customDate} onChange={(e) => onDateChange(e.target.value)}
          className="text-center font-bold text-[#162d3d] border-0 bg-transparent p-0 h-auto text-lg" data-testid="input-date" />
      </div>
      <div className={`p-4 rounded-lg ${dateModified ? 'bg-[#f59e0b]/10 border border-[#f59e0b]/30' : 'bg-[#f4f7fa]'}`}>
        <div className="flex items-center justify-between mb-2">
          <p className="text-xs text-[#8fa4b5] uppercase tracking-wide flex items-center gap-1"><Clock size={12} /> Heure</p>
        </div>
        <Input type="time" value={customTime} onChange={(e) => onTimeChange(e.target.value)}
          className="text-center font-bold text-[#162d3d] border-0 bg-transparent p-0 h-auto text-lg" data-testid="input-time" />
      </div>
      <div className="text-center p-4 bg-[#3899ec]/10 rounded-lg">
        <p className="text-xs text-[#8fa4b5] uppercase tracking-wide mb-2">Enregistré par</p>
        <p className="text-xl font-bold text-[#3899ec]" data-testid="coach-name">{userName}</p>
      </div>
    </div>
    {dateModified && (
      <div className="mt-4 flex items-center justify-between p-3 bg-[#f59e0b]/10 rounded-lg border border-[#f59e0b]/30">
        <div className="flex items-center gap-2 text-[#b45309]">
          <AlertCircle size={16} />
          <span className="text-sm">Date/heure modifiée manuellement - sera indiquée sur l'entrée</span>
        </div>
        <Button type="button" variant="ghost" size="sm" onClick={onReset} className="text-[#b45309] hover:text-[#92400e] text-xs">
          Remettre à maintenant
        </Button>
      </div>
    )}
  </div>
);
